import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';

const useSubscriptionPlan = () => {
  const { data: user } = useGetCurrentCustomerData();

  if (!user) return;

  return user.subscriptionPlan;
};

export default useSubscriptionPlan;
